"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GridRestrictionApi_gridRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRestrictionApi = void 0;
const AbstractSnapRestrictionApi_1 = require("../../AbstractSnapRestrictionApi");
class GridRestrictionApi extends AbstractSnapRestrictionApi_1.AbstractSnapRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _GridRestrictionApi_gridRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _GridRestrictionApi_gridRestriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (3)
    get gridUnit() {
        return __classPrivateFieldGet(this, _GridRestrictionApi_gridRestriction, "f").gridUnit;
    }
    set gridUnit(value) {
        __classPrivateFieldGet(this, _GridRestrictionApi_gridRestriction, "f").gridUnit = value;
    }
    get gridUnitEditable() {
        return __classPrivateFieldGet(this, _GridRestrictionApi_gridRestriction, "f").gridUnitEditable;
    }
}
exports.GridRestrictionApi = GridRestrictionApi;
_GridRestrictionApi_gridRestriction = new WeakMap();
//# sourceMappingURL=GridRestrictionApi.js.map